import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  message,
} from 'antd';

import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import getFormatedValues from 'utils/formatValues';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';
import { getVersionesVehiculares } from 'api/catalogos';
import { getTiposDeAplicacionesDeTarifasVehiculares } from 'api/catalogos/tipoDeAplicacionDeTarifasVehiculares';
import {
  deleteTabuladorVehicular,
  getTabuladoresVehiculares,
  patchTabuladorVehicular,
  postTabuladorVehicular,
} from 'api/catalogos/tabuladorDeValoresVehiulares';
import { onError } from 'utils/handlers';
import { ActionsNames, hasActionPermission } from 'utils/permission/index';

const models = ['versionvehicular'];

// eslint-disable-next-line react/prop-types
const TabuladorVehicular = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  // eslint-disable-next-line
  const [versionesVehicularesTemp, setVersionesVehicularesTemp] = useState({ results: [] });
  const [tipoDeAplicacion, setTipoDeAplicacion] = useState([]);
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const versionVehicular = useRef({ results: [] });

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getTabuladoresVehiculares({
      page,
      ...q,

    });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;

    const validatePermission = () => {
      const _hasAllViewPermission = models
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        setHasAllViewPermission(_hasAllViewPermission);
      }
    };
    const fetchAll = async () => {
      setLoading(true);
      const _tipoAplicacion = await getTiposDeAplicacionesDeTarifasVehiculares();
      if (mounted) {
        setTipoDeAplicacion(_tipoAplicacion);
        setLoading(false);
      }
    };
    validatePermission();
    fetchAll();
    fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setSelectedRowKeys([]);
    form.resetFields();
    setVisibleAlert(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = getFormatedValues(form.getFieldsValue());
      const [key] = selectedRowKeys;
      const saved = await (key ? patchTabuladorVehicular(key, values)
        : postTabuladorVehicular(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteTabuladorVehicular(key);
      if (deleted) {
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const onClickAdd = () => {
    setVisible(true);
    setSelectedRowKeys([]);
    form.resetFields();
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rules = {
    required: [{ required: true }],
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Año',
      dataIndex: 'anio',
      key: 'anio',
      width: 300,
    },
    {
      titleText: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
      width: 300,
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <Table
            cols={columns}
            data={data?.results}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            rowKey="id"
            allowImport
            mobileColIndex={0}
            allowColumnSelector={false}
            pagination={false}
            paginationCallback={fetchData}
            count={data.count}
            currentPage={currentPage}
            permission={permission}
            hasAllViewPermission={hasAllViewPermission}
          />
        ) : (
          <Card
            bordered={false}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
              />
            )}
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tabulador`}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    label="Año"
                    name="anio"
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    label="Valor"
                    name="valor"
                    decimal
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="version_vehicular"
                    label="Versión Vehícular"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select
                      // eslint-disable-next-line max-len
                      dataSource={versionesVehicularesTemp.results?.length ? versionesVehicularesTemp : versionVehicular.current}
                      pagination={{
                        getter: getVersionesVehiculares,
                        setter: (dataSource) => {
                          versionVehicular.current = dataSource;
                        },
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_aplicaciones_de_tarifas_vehiculares"
                    label="Tipo de Aplicación para el Cálculo"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Select dataSource={tipoDeAplicacion} />
                  </Form.Item>
                </Col>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => {
            setVisibleAlert(false);
            setSelectedRowKeys([]);
          }}
          visible={visibleAlert}
          content="Registro seleccionado"
        />
      </Spin>
    </Row>
  );
};
export default TabuladorVehicular;
